// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconItemsPath = 'M6 12.502h18v-3H6v3Zm16 11c0 .551-.448 1-1 1H8.777c-.551 0-1-.449-1-1v-9H22v9Zm4-16h-9.032c.1-.094.206-.181.295-.29l2.511-3.078-1.548-1.264-2.513 3.078c-.193.237-.513.35-.786.368a1 1 0 0 1-.779-.387l-2.358-3.04-1.58 1.226 2.358 3.04c.101.13.22.238.338.347H4v7h1.777v9c0 1.654 1.346 3 3 3H21c1.654 0 3-1.346 3-3v-9h2v-7Z';
var NavigationIconItems = baseIcon('NavigationIconItems', {
  getPath: () => NavigationIconItemsPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconItems;
//# sourceMappingURL=index.js.map